import styled from 'styled-components';

export const ContainerImage = styled.div`
margin-top: 20px;
img {
	width: 100%;
	height: 100%;
	min-height: 180px;
	background-repeat: no-repeat !important;
	background-position: center !important;
	background-size: cover !important; 
	position: relative !important;
}
		
`;
